import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FileAttachmentComponent } from './file-attachment.component';

@NgModule({
    declarations: [FileAttachmentComponent],
    imports: [CommonModule, TranslateModule],
    exports: [FileAttachmentComponent],
})
export class FileAttachmentModule {}
